import { PropsWithChildren } from "react";

const Pill = ({
  label,
  className,
  children,
  onClick
}: PropsWithChildren<{
  label?: string;
  className?: string;
  onClick?: () => void;
}>) => (
  <span
    className={
      "w-fit break-all rounded-lg font-semibold text-black " + className
    }
    onClick={onClick}
  >
    {label ? label : children}
  </span>
);

export default Pill;
